// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress__hEFpc","circle":"circle__zXU6V","completed":"completed__KbffK","in-progress":"in-progress__9sHC8","not-started":"not-started__JDxLG"};